export default "__VITE_ASSET__DxLq6K5r__"